
export function controls() {
	return `
				<div class="controls">
					<div class="filter">
						<h2>
							Filter Property Listing by:
						</h2>
						<div class="buttons">
							<button class="orange-button all-listings" data-listing-type="all">
								All Listings
							</button>	
							<button class="orange-button unselected for-sale-listings" data-listing-type="for-sale">
								For Sale
							</button>	
							<button class="orange-button unselected for-lease-listings" data-listing-type="for-lease">
								For Lease
							</button>	
							<button class="orange-button unselected sold-listings" data-listing-type="sold">
								Sold / Leased
							</button>	
						</div>
						
					</div>
					<div class="search">
						<h2>
							Search Properties
						</h2>
						<form id="search-properties-form">
							<input type="text" placeholder="Search" name="search" />
							<button type="submit"><img src="/img/mag-glass.png" /></button>
						</form>
					</div>
				</div>
`
	
}

function propertyTypeActiveClass(propertyType) {
	if(!propertyType) {
		return ''
	}
	propertyType = propertyType.toLowerCase()
	if(propertyType === 'for sale') {
		return 'active'
	}
	if(propertyType === 'for lease') {
		return 'active'
	}
	if(propertyType === 'for sale or lease') {
		return 'active'
	}

	return ''
}

export function propertyTile(property) {
return `	
<div class="property">
	<div class="top">
		<a href="/property?propertyId=${property.id}">
			<div class="badge ${propertyTypeActiveClass(property.propertyType)}">${property.propertyType}</div>
			<img src="${property.imageUrl}" />
		</a>	
	</div>
	<div class="bottom">
		<h3>
			${property.title}
		</h3>
		<h4>
			${property.propertyType}
		</h4>
		<p class="address">
			<strong>
				${property.address}
			</strong>
		</p>
		<div class="desc">
			${property.desc}
		</div>
		<div class="view-details">
			<a href="/property?propertyId=${property.id}">View Details &gt;</a>	
		</div>
	</div>
</div>
`
}